export type MadBundayCode = 'AFL' | 'NRL'

export const madBundayTeamAfl = [
  'Adelaide',
  'Brisbane',
  'Carlton',
  'Collingwood',
  'Essendon',
  'Fremantle',
  'Geelong',
  'Gold Coast',
  'Greater Western Sydney',
  'Hawthorn',
  'Melbourne',
  'North Melbourne',
  'Port Adelaide',
  'Richmond',
  'St Kilda',
  'Sydney',
  'West Coast',
  'Western Bulldogs'
]

export const madBundayTeamNrl = [
  'Brisbane',
  'Canberra',
  'Canterbury',
  'Cronulla',
  'Dolphins',
  'Gold Coast',
  'Manly',
  'Melbourne Storm',
  'Newcastle',
  'North Queensland',
  'Parramatta',
  'Penrith',
  'South Sydney',
  'St George',
  'Sydney',
  'Warriors',
  'Wests Sydney'
]
